export default {
    state: {
        percent: 0,
        show: false,
        canSuccess: true,
        duration: 3000,
        height: '2px',
        color: '#77b6ff',
        failedColor: 'red',
        timer: null,
        cut: 0,
    },

    getters: {
        loadingStyle(state) {
            return {
                width: `${state.percent}%`,
                height: state.height,
                opacity: state.show ? 1 : 0,
                'background-color': state.canSuccess ? state.color : state.failedColor,
            };
        },

        getPercent(state) {
            return Math.floor(state.percent);
        },
    },

    actions: {
        start({ commit, dispatch, state }) {
            commit('STOP_TIMER'); // Ensure any existing timer is cleared

            commit('SET_SHOW', true);
            commit('SET_CAN_SUCCESS', true);
            commit('SET_PERCENT', 0);
            commit('SET_CUT', 100000 / Math.floor(state.duration));

            const timer = setInterval(() => {
                dispatch('increase', state.cut * Math.random()).catch(console.error);
                if (state.percent > 95) {
                    dispatch('finish').catch(console.error);
                }
            }, 100);
            commit('SET_TIMER', timer);
        },

        set({ commit, dispatch }, num) {
            if (num < 0 || num > 100) {
                console.error('Percent value must be between 0 and 100');
                return;
            }

            dispatch('pause'); // Pause any ongoing loading before setting percent
            commit('SET_SHOW', true);
            commit('SET_CAN_SUCCESS', true);
            commit('SET_PERCENT', Math.floor(num));
        },

        increase({ commit, state }, num) {
            const newPercent = state.percent + Math.floor(num);
            commit('SET_PERCENT', newPercent > 100 ? 100 : newPercent);
        },

        decrease({ commit, state }, num) {
            const newPercent = state.percent - Math.floor(num);
            commit('SET_PERCENT', newPercent < 0 ? 0 : newPercent);
        },

        finish({ commit, dispatch }) {
            commit('SET_PERCENT', 100);
            dispatch('hide').catch(console.error);
        },

        pause({ commit }) {
            commit('STOP_TIMER');
        },

        hide({ commit }) {
            commit('STOP_TIMER');
            commit('SET_SHOW', false);
            setTimeout(() => {
                commit('SET_PERCENT', 0);
            }, 500);
        },

        fail({ commit }) {
            commit('SET_CAN_SUCCESS', false);
        },
    },

    mutations: {
        SET_PERCENT(state, payload) {
            state.percent = payload;
        },
        SET_SHOW(state, payload) {
            state.show = payload;
        },
        SET_CAN_SUCCESS(state, payload) {
            state.canSuccess = payload;
        },
        SET_TIMER(state, payload) {
            state.timer = payload;
        },
        SET_CUT(state, payload) {
            state.cut = payload;
        },
        STOP_TIMER(state) {
            if (state.timer) {
                clearInterval(state.timer);
                state.timer = null;
            }
        },
    },
};
